import { t } from 'i18next';
import moment from 'moment';
import { BusinessAreaDto } from 'src/models/businessArea.model';
import { IListSkills } from 'src/models/comonModels';
import { SelectDTO } from 'src/models/selectDTO.model';
const domParser = new DOMParser();
export const last10daydate = new Date(
  new Date().getTime() - 10 * 24 * 60 * 60 * 1000,
);

export const getDateAddingOrRemovingDays = (currentDate: Date, days: number) => {
  return new Date(
    currentDate.getTime() + days * 24 * 60 * 60 * 1000,
  )
};

export const getDateISOGMT = (currentDate: Date) => {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      currentDate.getHours(),
      currentDate.getMinutes(),
    ),
  ).toISOString();
};

export const getDateISOGMTWithoutMinutes = (currentDate: Date) => {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      0,
      0,
      0,
    ),
  ).toISOString();
};

export const getDateISOGMTWithGivenMinutes = (currentDate: Date, hours: number, minutes: number) => {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      hours,
      minutes,
      0,
    ),
  ).toISOString();
};

export const getDateISOGMTAddinghours = (
  currentDate: Date,
  hour: number = 0,
  minute: number = 0,
) => {
  return new Date(
    Date.UTC(
      currentDate.getFullYear(),
      currentDate.getMonth(),
      currentDate.getDate(),
      currentDate.getHours() + hour,
      currentDate.getMinutes() + minute,
      0,
    ),
  ).toISOString();
};

export const getDateIsoToFormat = (currentDate: string) => {
  const date = new Date(currentDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const dt = date.getDate();
  let monthTxt = '' + month;
  let dtTxt = '' + dt;

  if (dt < 10) {
    dtTxt = '0' + dt;
  }
  if (month < 10) {
    monthTxt = '0' + month;
  }
  return dtTxt + '/' + monthTxt + '/' + year;
};

export const getDateIsoToFormatUS = (currentDate: string) => {
  const date = new Date(currentDate);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const dt = date.getDate();
  let monthTxt = '' + month;
  let dtTxt = '' + dt;

  if (dt < 10) {
    dtTxt = '0' + dt;
  }
  if (month < 10) {
    monthTxt = '0' + month;
  }
  return year + '-' + monthTxt + '-' + dtTxt;
};

export const getUSsDateDashed = (currentDate: string) => {
  const isoDate = getDateISOGMTWithoutMinutes(moment(currentDate, 'DD/MM/YYYY').toDate());
  return isoDate.split('T')[0];
};

export const getFooterTotal = (id: string, info: any, price: boolean = false) => {
  const rows = info.filteredRows;
  let sum = 0;

  rows.map((a: any) => {
    if (a.id) {
      if (price) {
        sum = sum + Number(a.values[id].replace('€', '').replace(',', '.').replace(/ /g, '').trim());
      } else {
        sum = sum + Number(a.values[id]);
      }

    }
  });
  return sum.toLocaleString();
};

export const getFooterCount = (info: any) => {
  const rows = info.filteredRows;

  return rows.length;
};

export const formatDateField = (date: string) => {
  const lang = navigator.language;
  let res = '';

  if (date) {
    const aDate = date.substring(0, 10).split('-');

    if (lang === 'fr') {
      res = `${aDate[2]}/${aDate[1]}/${aDate[0]}`;
    } else {
      res = `${aDate[1]}/${aDate[2]}/${aDate[0]}`;
    }
  }
  return res;
}

export const separateurMilliers = (nb: string, separateur?: string) => {
  let currency = '';
  if (nb.includes('€')) {
    currency = '€';
    nb = nb.replace('€', '');
  }

  let strNb = nb.trim();

  let partieEntiere: any = Number(strNb.split(',')[0]);
  let partieDecimale = strNb.split(',')[1];

  partieEntiere = (partieEntiere !== null) ? partieEntiere.toLocaleString() : '';
  partieDecimale = partieDecimale ? `,${partieDecimale}` : '';

  const result = `${partieEntiere}${partieDecimale}`;
  return currency ? `${result} ${currency}` : result;
}

export const appendZero = (str: string | any) => {
  return Number(str) < 10 ? `0${str}` : str;
};

export const currencyToNumber = (strCurrency: string) => {
  return Number(strCurrency.replace(' €', '').replace(',', '.'));
};

export function base64ToArrayBuffer(base64) {
  var binaryString = window.atob(base64);
  var binaryLen = binaryString.length;
  var bytes = new Uint8Array(binaryLen);
  for (var i = 0; i < binaryLen; i++) {
    var ascii = binaryString.charCodeAt(i);
    bytes[i] = ascii;
  }
  return bytes;
}

export function checkIfSkillExist(references: SelectDTO[], value: string) {
  const currentSkill = (value === undefined || value === null) ? [] : value.split(' / '); // value.split(/[\/;,]/);
  let alreadyExist: SelectDTO[] = [];
  currentSkill.forEach(option => {
    const temp = references.filter(x => x.label?.toLowerCase() === option.trim().toLowerCase());
    if (temp.length > 0) {
      alreadyExist = alreadyExist.concat(temp);
    }
  });
  return [...new Set(alreadyExist)];
}

export function checkIfSkillBusinessAreaOtherExist(data: BusinessAreaDto[], value: string) {
  const currentData = (value === undefined || value === null) ? [] : value.split(' / ');
  let alreadyExist: BusinessAreaDto[] = [];
  currentData.forEach(option => {
    const temp = data.filter(x => x.name?.toLowerCase() === option.trim().toLowerCase());
    if (temp.length > 0) {
      alreadyExist = alreadyExist.concat(temp);
    }
  });
  return [...new Set(alreadyExist)];
}

export function checkIfNameFrExist(references: IListSkills[], value: string) {
  const currentSkill = (value === undefined || value === null) ? [] : value.split(' / ');
  let alreadyExist: IListSkills[] = [];
  currentSkill.forEach(option => {
    const temp = references.filter(x => x.nameFr?.toLowerCase() === option.trim().toLowerCase());
    if (temp.length > 0) {
      alreadyExist = alreadyExist.concat(temp);
    }
  });
  return [...new Set(alreadyExist)];
}

export function checkIfNameEnExist(references: IListSkills[], value: string) {
  const currentSkill = (value === undefined || value === null) ? [] : value.split(' / ');
  let alreadyExist: IListSkills[] = [];
  currentSkill.forEach(option => {
    const temp = references.filter(x => x.nameEn?.toLowerCase() === option.trim().toLowerCase());
    if (temp.length > 0) {
      alreadyExist = alreadyExist.concat(temp);
    }
  });
  return [...new Set(alreadyExist)];
}

export function checkIfIdBoondExist(references: IListSkills[], value: string) {
  const currentSkill = (value === undefined || value === null) ? [] : value.split(' / ');
  let alreadyExist: IListSkills[] = [];
  // currentSkill.forEach(option => {
  //   const temp = references.filter(x => x.idBoond === parseInt(option.trim()));
  //   if (temp.length > 0) {
  //     alreadyExist = alreadyExist.concat(temp);
  //   }
  // });
  currentSkill.forEach(option => {
    const temp = references.filter(x => x.idBoond?.toLowerCase() === option.trim().toLowerCase());
    if (temp.length > 0) {
      alreadyExist = alreadyExist.concat(temp);
    }
  });
  return [...new Set(alreadyExist)];
}

export function padL(nr, len = 2, chr = `0`) {
  return `${nr}`.padStart(2, chr);
}

export function strip(html) {
  let doc = domParser.parseFromString(html, 'text/html');
  return doc.body.textContent.trim() || "";
}

export function normalizeHtml(input: string): string {
  return input
    .replace(/＜/g, "<")
    .replace(/＞/g, ">")
    .replace(/＆/g, "&")
    .replace(/＂/g, "\"")
    .replace(/＇/g, "'");
}

export function formatDate(dateString) {
  const d = new Date(dateString);
  const day = String(d.getDate()).padStart(2, "0");
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const year = String(d.getFullYear()).slice(-2);
  const hours = String(d.getHours()).padStart(2, "0");
  const minutes = String(d.getMinutes()).padStart(2, "0");

  return `${day}/${month}/${year} ${t('EEPAttachments.at')} ${hours}:${minutes}`;
};

const parseMonth = (m) => {
  const n = parseInt(m, 10);
  return Number.isInteger(n) && n >= 1 && n <= 12 ? n : null;
};

const parseYear = (y) => {
  const n = parseInt(y, 10);
  return Number.isInteger(n) ? n : null;
};

export function calculateDuration(startMonth, startYear, endMonth, endYear) {
  if (
    startMonth == null &&
    startYear == null &&
    endMonth == null &&
    endYear == null
  ) {
    return 0;
  }

  const now = new Date();

  const finalStartMonth = parseMonth(startMonth) ?? 1;
  const finalStartYear = parseYear(startYear) ?? now.getFullYear();

  const finalEndMonth = parseMonth(endMonth) ?? 12;
  const finalEndYear = parseYear(endYear) ?? now.getFullYear();

  const startTotalMonths = finalStartYear * 12 + (finalStartMonth - 1);
  const endTotalMonths = finalEndYear * 12 + finalEndMonth;

  const diffMonths = endTotalMonths - startTotalMonths;

  if (diffMonths <= 0) return 0;

  return diffMonths;
}
